export default __webpack_public_path__ + "static/media/logo.b84080a1.svg";